/* eslint-disable no-console */
import {isDevelopment} from './utils.js'

export default function ReactHooks() {
  if (isDevelopment) {
    console.warn(
      "[@adv-mt/mt-tracking-use-csat] can't be used as a standalone package.\nYou must import a specific hook."
    )
  }
  return null
}

export {default as useCsat} from './use-csat.js'
